import React from 'react';
import { Section } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { GoldButton } from '../ui/GoldButton';
import { ValueStack } from './offer/ValueStack';
import { Pillars } from './offer/Pillars';
import { MythTable } from './offer/MythTable';
import { EmpathyCallout } from './offer/EmpathyCallout';
export function Offer() {
  return <Section id="oferta" className="bg-mist" aria-labelledby="oferta-titulo" data-id="element-145" data-mp="3549fmg6irheq">
      <ValueStack data-id="element-146" data-mp="3a4xetp4wj4k1" />

      <Reveal delay={0.1} data-id="element-147" data-mp="3a3cko0mi1nmp">
        <div className="mt-10 flex justify-center" data-id="element-148" data-mp="3f4a2gc3lkfno">
          <GoldButton href="#comprar" data-id="element-149" data-mp="3f2p6qj5jqqo8">Sí, Quiero Mi Mapa Ahora</GoldButton>
        </div>
      </Reveal>

      <Pillars data-id="element-150" data-mp="3jw1t0mmr6ldt" />

      <Reveal delay={0.06} data-id="element-151" data-mp="3jxmdfjfcsnxy">
        <div className="mt-10 flex justify-center" data-id="element-152" data-mp="3nxdbm877m6ci">
          <GoldButton href="#comprar" data-id="element-153" data-mp="3nw25w2u7eoir">Muéstrame Cómo Aplicar El Código 1-2-3</GoldButton>
        </div>
      </Reveal>

      <MythTable data-id="element-154" data-mp="3su3rauf3qzxe" />

      <EmpathyCallout data-id="element-155" data-mp="1pdoaxvm808o" />

      <Reveal delay={0.06} data-id="element-156" data-mp="1qout5gg3m3h">
        <div className="mt-12 flex flex-col items-center" data-id="element-157" data-mp="1pwy1rb43ibm">
          <GoldButton href="#comprar" data-id="element-158" data-mp="1klqd8czikts7">Quiero El Método Completo Hoy</GoldButton>
          <p className="mt-4 text-xs text-muted" data-id="element-159" data-mp="1fmn5gks5g9gj">
            Pago único · acceso inmediato · garantía de 60 días
          </p>
        </div>
      </Reveal>
    </Section>;
}